/**
 * Formats a phone number to (XXX) XXX-XXXX. Strips a leading US country code
 * if present. Returns '—' for missing values; falls back to the raw input for
 * non-10-digit values that can't be normalized.
 */
export function formatPhone(phone?: number | string | null): string {
  if (phone === undefined || phone === null || phone === '') return '—';
  const raw = String(phone);
  const digits = raw.replace(/\D/g, '');
  const d = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
  if (d.length !== 10) return raw;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
